module.exports = __webpack_public_path__ + "img/people-first.1b194aa6.jpg";